import axios from "axios";
import { BACKEND_URL } from "../config_and_helpers/config";
import { logError } from "../config_and_helpers/logger";

export const fetchCurrencies = async (token) => {
  try {
    const response = await axios.get(`${BACKEND_URL}serve_currencies/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    logError("currency_client", "fetchCurrencies failed", error.response?.data ?? error);
    return Object.values(error.response?.data ?? {});
  }
};
